import { WoltLogo } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { useIsMobile } from 'common/hooks/useIsMobile';
import { FeatureType } from 'common/types';
import UserDropdown from 'modules/header/components/UserDropdown';

export type Props = {
  selectedVenueSlug?: string;
  selectedFeature?: FeatureType;
  hideVenueSelector: boolean;
};

const Root = styled.div<{ isMobile: boolean }>`
  display: flex;
  width: 100%;
  height: 100px;
  padding: 10px 24px;
  justify-content: space-between;
`;

const StyledWoltLogo = styled(WoltLogo)`
  height: 16px;
`;

const OnboardingPageHeader = () => {
  const isMobile = useIsMobile();

  return (
    <Root isMobile={isMobile}>
      <StyledWoltLogo />
      <UserDropdown />
    </Root>
  );
};

export default OnboardingPageHeader;
